import React, { useEffect } from 'react'
import {
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Grid,
    Snackbar,
    CircularProgress,
} from "@material-ui/core";
import { UpdateFileAction } from '../apis';


function EditFileName({ open, onClose, selectedFile, fetch, type }) {

    const [name, setName] = React.useState()
    const [updating, setUpdating] = React.useState(false)

    useEffect(() => {
        if (selectedFile) {
            setName(selectedFile[type])
        }
    }, [selectedFile])

    const onChangeFile = (evt) => {
        setName(evt.target.value)
    }

    const onUpdate = async () => {
        setUpdating(true)
        let res = await UpdateFileAction(selectedFile._id, { [type]: name })
        setUpdating(false)
        onClose()
        fetch()
    }
    return (
        <Grid item>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="form-dialog-title"
                maxWidth='xs'
                fullWidth="100%"
                className="m-0"
            >
                <DialogTitle id="form-dialog-title">
                    <Typography variant="h6">{`Edit ${type.toUpperCase()} Name`}</Typography>
                </DialogTitle>
                <DialogContent>
                    <input
                        className="form-control form-control-solid h-auto py-5 px-6 my-3"
                        autoFocus
                        margin="dense"
                        placeholder={`Edit ${type.toUpperCase()} Name`}
                        type="text"
                        value={name}
                        onChange={onChangeFile}
                        required
                    />
                </DialogContent>
                <DialogActions>
                    <Grid
                        className="px-5 mb-4"
                        container
                        direction="row"
                        justify="space-between"
                    >
                        <Grid item>
                            <Button
                                size="large"
                                onClick={onClose}
                                variant={"contained"}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                size="large"
                                onClick={() => onUpdate()}
                                color="secondary"
                                variant={"contained"}
                                className="px-10"

                            >
                                {updating ? (
                                    <CircularProgress
                                        size="20px"
                                        style={{
                                            color: "#ffffff",
                                            marginLeft: "9px",
                                            marginRight: "9px",
                                        }}
                                        class=""
                                    />
                                ) : (
                                    <Typography style={{ width: "38px", height: "20px" }}>
                                        Update
                                    </Typography>
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default EditFileName